/* BYON · carro lateral (Dawn 10 + agente Carro), R1-R2 24-sep-2026. Contrato K2 y detalle: impl/reports/carro-r2.md.
   - refresh(): 1 petición a '?sections=cart-drawer,cart-icon-bubble' SIN Accept: application/json; repinta solo si
     la firma del carro cambió y nunca pinta una respuesta más vieja que lo ya pintado.
   - Filas por key: cantidad y "Eliminar" van a /cart/change.js con { id: key }, nunca con line.
   - Propio = byonCart.markOwn() ±2 s (carro, agregados, renderContents). Lo ajeno (FBT, otra app) se detecta con
     PerformanceObserver: un /cart/add ajeno abre el carro y mide add_to_cart { atc_source: 'external' }; si la app
     redirige, la medición pasa por sessionStorage a la página siguiente.
   - Otra pestaña o página vieja: visibilitychange, pageshow persistido y HTML desde caché (Atrás) → verify().
   API que usan product-form.js, quick-add.js y byon-product.js: open, close, renderContents, getSectionsToRender,
   getSectionInnerHTML, getSectionDOM, setActiveElement. */
(() => {
  if (customElements.get('cart-drawer')) return;

  const B = (window.byonCart = window.byonCart || {});
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const OWN_MS = 2000;
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/;
  const EXT_KEY = 'byonCartExternalAdd';

  const rootUrl = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const changeUrl = () => `${(window.routes && window.routes.cart_change_url) || `${rootUrl()}cart/change`}.js`;
  const getDrawer = () => document.querySelector('cart-drawer');
  const cssEscape = (value) => (window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&'));
  const cartError = () => (window.cartStrings && window.cartStrings.error) || 'No pudimos actualizar tu carro. Inténtalo de nuevo.';

  B.markOwn = () => {
    B._own = Date.now();
  };
  const isOwn = (time) => typeof B._own === 'number' && Math.abs(time - B._own) < OWN_MS;

  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }

    connectedCallback() {
      if (this.cartUpdateUnsubscriber || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const source = event && event.source;
        if (!this.classList.contains('active')) {
          this.stale = true;
        } else if (!['cart-items', 'cart-drawer-items', 'product-form', 'byon-cart'].includes(source)) {
          this.refresh();
        }
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
        this.cartUpdateUnsubscriber = undefined;
      }
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code && event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      if (this.stale) {
        this.stale = false;
        this.refresh();
      } else if (!this.skipVerify) {
        this.verify();
      }
      this.skipVerify = false;
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

      document.body.classList.add('overflow-hidden', 'byon-overlay-open');

      if (this.classList.contains('active')) {
        this.trapDrawerFocus();
        return;
      }
      this.focusTrapped = false;
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });
      this.addEventListener('transitionend', () => this.trapDrawerFocus(), { once: true });
      // Sin transición (prefers-reduced-motion) no hay transitionend: se atrapa el foco igual.
      setTimeout(() => {
        if (!this.focusTrapped && this.classList.contains('active')) this.trapDrawerFocus();
      }, 450);
    }

    trapDrawerFocus() {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (containerToTrapFocusOn && focusElement && typeof trapFocus === 'function') {
        trapFocus(containerToTrapFocusOn, focusElement);
        this.focusTrapped = true;
      }
    }

    close() {
      this.classList.remove('active');
      this.focusTrapped = false;
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden', 'byon-overlay-open');
      document.dispatchEvent(new CustomEvent('byon:cart:closed'));
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      if (typeof onKeyUpEscape === 'function') cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    /* La usan product-form.js, quick-add.js y byon-product.js después de /cart/add con sections. */
    renderContents(parsedState) {
      B.markOwn();
      const inner = this.querySelector('.drawer__inner');
      if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
      this.productId = parsedState.id;
      this.stale = false;
      let painted = false;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
        const html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        if (html !== null) {
          sectionElement.innerHTML = html;
          painted = true;
        }
      });
      this.syncEmptyState();
      if (painted) {
        this.paintSeq = (this.paintSeq || 0) + 1;
        this.emitUpdated();
      }

      setTimeout(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.skipVerify = true;
        this.open();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return element ? element.innerHTML : null;
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    /* Pinta las secciones 'cart-drawer' y 'cart-icon-bubble' sin reabrir el carro. */
    applySections(sections) {
      if (!sections) return false;
      let painted = false;
      if (sections['cart-drawer']) {
        const source = this.getSectionDOM(sections['cart-drawer'], '.drawer__inner');
        const target = this.querySelector('.drawer__inner');
        if (source && target) {
          target.innerHTML = source.innerHTML;
          painted = true;
        }
        this.syncEmptyState();
      }
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const source = this.getSectionDOM(sections['cart-icon-bubble']);
        if (bubble && source) bubble.innerHTML = source.innerHTML;
      }
      if (painted) {
        this.paintSeq = (this.paintSeq || 0) + 1;
        this.stale = false;
        this.emitUpdated();
      }
      return painted;
    }

    syncEmptyState() {
      const isEmpty = !!this.querySelector('.drawer__inner-empty');
      this.classList.toggle('is-empty', isEmpty);
      const items = this.querySelector('cart-drawer-items');
      if (items) items.classList.toggle('is-empty', isEmpty);
    }

    paintedSig() {
      const state = this.querySelector('[data-byon-cart-sig]');
      return state ? state.dataset.byonCartSig : '';
    }

    emitUpdated() {
      const parts = String(this.paintedSig()).split('|');
      document.dispatchEvent(
        new CustomEvent('byon:cart:updated', {
          detail: { item_count: Number(parts[0]) || 0, total_price: Number(parts[1]) || 0 },
        })
      );
    }

    fetchSections() {
      // no-store: con Atrás, Chrome sirve desde caché lo que se pide al cargar.
      return fetch(`${rootUrl()}?sections=${SECTIONS.join(',')}`, { cache: 'no-store' })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.json();
        })
        .then((sections) => {
          if (!sections || !sections['cart-drawer']) throw new Error('la respuesta no trae la sección cart-drawer');
          return sections;
        });
    }

    /* K2. Nunca recarga la página. Llamadas simultáneas: 1 petición y otra al terminar (máx. 4). true si repintó. */
    refresh(openAfter = false) {
      if (openAfter) this.openAfterRefresh = true;
      if (this.refreshing) {
        this.refreshAgain = true;
        return this.refreshing;
      }
      let changed = false;
      const once = () => {
        const seq = this.paintSeq || 0;
        return this.fetchSections()
          .then((sections) => {
            this.stale = false;
            const state = this.getSectionDOM(sections['cart-drawer'], '[data-byon-cart-sig]');
            const next = state ? state.dataset.byonCartSig : null;
            if (next !== null && next === this.paintedSig()) return;
            // Otro código pintó entretanto: esta respuesta puede ser más vieja. Se pide de nuevo.
            if ((this.paintSeq || 0) !== seq) {
              this.refreshAgain = true;
              return;
            }
            if (this.applySections(sections)) changed = true;
          })
          .catch((error) => console.warn('[BYON carro] No se pudo actualizar el carro lateral', error));
      };
      const loop = (round) =>
        once().then(() => {
          const again = this.refreshAgain && round < 4;
          this.refreshAgain = false;
          return again ? loop(round + 1) : undefined;
        });
      this.refreshing = loop(1).then(() => {
        this.refreshing = null;
        if (this.openAfterRefresh) {
          this.openAfterRefresh = false;
          this.skipVerify = true;
          this.open();
        }
        return changed;
      });
      return this.refreshing;
    }

    /* Resuelve true si volvió a pintar. */
    verify() {
      return this.refresh();
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  /* Filas del carro lateral: cantidad y "Eliminar" por key (C1-CAR-01). Una fila vieja nunca toca otra línea. */
  const defineCartDrawerItems = () => {
    if (customElements.get('cart-drawer-items')) return true;
    if (typeof CartItems === 'undefined') return false;

    class CartDrawerItems extends CartItems {
      // El carro lateral se actualiza con la Section Rendering API (CartDrawer.refresh / applySections).
      onCartUpdate() {}

      getSectionsToRender() {
        return [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];
      }

      rowFor(key) {
        return key ? document.querySelector(`#CartDrawer .byon-cart-line[data-key="${cssEscape(key)}"]`) : null;
      }

      showLineError(key, line, message) {
        const row = this.rowFor(key) || document.getElementById(`CartDrawer-Item-${line}`);
        const text = row ? row.querySelector('.cart-item__error-text') : null;
        if (text) text.textContent = message || '';
      }

      announce(message) {
        const region = document.getElementById('CartDrawer-LiveRegionText');
        if (!region) return;
        region.textContent = '';
        setTimeout(() => {
          region.textContent = message;
        }, 60);
      }

      enableLoading(line) {
        const items = document.getElementById('CartDrawer-CartItems');
        if (items) items.classList.add('cart__items--disabled');
        document.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
        const status = document.getElementById('CartDrawer-LineItemStatus');
        if (status) status.setAttribute('aria-hidden', 'false');
      }

      disableLoading(line) {
        const items = document.getElementById('CartDrawer-CartItems');
        if (items) items.classList.remove('cart__items--disabled');
        document.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`).forEach((overlay) => overlay.classList.add('hidden'));
        const status = document.getElementById('CartDrawer-LineItemStatus');
        if (status) status.setAttribute('aria-hidden', 'true');
      }

      updateQuantity(line, quantity, name) {
        const drawer = getDrawer();
        const row = document.getElementById(`CartDrawer-Item-${line}`);
        const key = row ? row.dataset.key : '';
        if (!drawer || !key) {
          if (drawer) drawer.refresh();
          return;
        }
        const titleEl = row.querySelector('.cart-item__name');
        const title = titleEl ? titleEl.textContent.trim() : '';
        const input = row.querySelector('.quantity__input');
        const qty = Math.max(0, parseInt(quantity, 10) || 0);
        this.enableLoading(line);
        B.markOwn();
        const config = typeof fetchConfig === 'function'
          ? fetchConfig('json')
          : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
        config.body = JSON.stringify({ id: key, quantity: qty, sections: SECTIONS, sections_url: window.location.pathname });

        fetch(changeUrl(), config)
          .then((response) => response.json().then((state) => ({ ok: response.ok, state })))
          .then(({ ok, state }) => {
            if (!ok || !state || state.errors || state.status) {
              if (input) input.value = input.getAttribute('value');
              this.showLineError(key, line, (state && (state.errors || state.description || state.message)) || cartError());
              drawer.verify();
              return;
            }
            drawer.applySections(state.sections);
            const item = (state.items || []).find((entry) => entry.key === key);
            const newRow = this.rowFor(key);
            if (qty > 0 && item && item.quantity !== qty && window.cartStrings && window.cartStrings.quantityError) {
              this.showLineError(key, line, window.cartStrings.quantityError.replace('[quantity]', item.quantity));
            }
            if (qty === 0 && title) this.announce(`${title}: eliminado del carro.`);

            const empty = drawer.classList.contains('is-empty');
            const container = empty ? drawer.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
            let target = null;
            if (newRow) target = (name && newRow.querySelector(`[name="${name}"]`)) || newRow.querySelector('.cart-item__name');
            if (!target && empty && container) target = container.querySelector('a, button');
            if (!target) target = drawer.querySelector('#CartDrawer .cart-item__name') || drawer.querySelector('.drawer__inner');
            if (container && target && typeof trapFocus === 'function') trapFocus(container, target);

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-items' });
            }
          })
          .catch((error) => {
            console.warn('[BYON carro] No se pudo cambiar la cantidad', error);
            this.showLineError(key, line, cartError());
          })
          .finally(() => this.disableLoading(line));
      }
    }

    customElements.define('cart-drawer-items', CartDrawerItems);
    return true;
  };

  if (!defineCartDrawerItems()) {
    document.addEventListener('DOMContentLoaded', defineCartDrawerItems);
  }

  /* Contrato K2: API pública. */
  B.openDrawer = (trigger) => {
    const drawer = getDrawer();
    if (drawer && typeof drawer.open === 'function') drawer.open(trigger);
  };
  B.refreshDrawer = (open) => {
    B.markOwn(); // quien la llama después de agregar ya mide su propio add_to_cart
    const drawer = getDrawer();
    if (!drawer || typeof drawer.refresh !== 'function') return Promise.resolve();
    return drawer.refresh(open === true).then(() => undefined);
  };
  B.verifyDrawer = () => {
    const drawer = getDrawer();
    return drawer && typeof drawer.verify === 'function' ? drawer.verify() : Promise.resolve(false);
  };

  /* Llamadas hechas antes de que cargara este archivo (cola del script en línea de snippets/cart-drawer.liquid). */
  const queued = Array.isArray(B._queue) ? B._queue.splice(0) : [];
  if (queued.length) {
    const wantsOpen = queued.some((entry) => entry.open);
    B.refreshDrawer(wantsOpen).then(() => queued.forEach((entry) => entry.resolve && entry.resolve()));
  }

  /* Medición de un /cart/add ajeno (K1): diferencia entre la firma pintada antes y la de después. Los datos de cada
     línea salen de la fila pintada (data-key, data-variant-id, data-product-id, data-price y el nombre). */
  const parseSig = (sig) => {
    const parts = String(sig || '').split('|');
    const lines = {};
    parts
      .slice(2)
      .join('|')
      .split(',')
      .forEach((pair) => {
        const cut = pair.lastIndexOf(':');
        if (cut > 0) lines[pair.slice(0, cut)] = Number(pair.slice(cut + 1)) || 0;
      });
    return { count: Number(parts[0]) || 0, total: Number(parts[1]) || 0, lines };
  };
  const trackExternalAdd = (beforeSig, afterSig) => {
    const a = parseSig(beforeSig);
    const b = parseSig(afterSig);
    const units = b.count - a.count;
    const added = Object.keys(b.lines)
      .filter((key) => b.lines[key] > (a.lines[key] || 0))
      .map((key) => {
        const row = document.querySelector(`#CartDrawer .byon-cart-line[data-key="${cssEscape(key)}"]`);
        const name = row ? row.querySelector('.cart-item__name') : null;
        return {
          item: row ? row.dataset.productId || '' : '',
          variant: (row && row.dataset.variantId) || key.split(':')[0],
          name: name ? name.textContent.trim() : '',
          price: row ? Number(row.dataset.price) || 0 : 0,
        };
      });
    if (units <= 0 || !added.length) return;
    const data = {
      atc_source: 'external',
      item_id: added.map((line) => line.item).join(','),
      variant_id: added.map((line) => line.variant).join(','),
      item_name: added.map((line) => line.name).join(' + '),
      quantity: units,
      value: Math.round((b.total - a.total) / 100),
      lines: added.length,
      currency: 'CLP',
    };
    if (added.length === 1 && added[0].price) data.price = Math.round(added[0].price / 100);
    try {
      window.byonTrack && window.byonTrack('add_to_cart', data);
    } catch (error) {
      /* la medición nunca bloquea el carro */
    }
  };
  const paintedSig = () => {
    const drawer = getDrawer();
    return drawer && typeof drawer.paintedSig === 'function' ? drawer.paintedSig() : null;
  };
  /* Un agregado ajeno que quedó sin medir porque la página se fue (la app redirige a /cart). */
  const resumeExternalAdd = () => {
    let record = null;
    try {
      record = JSON.parse(sessionStorage.getItem(EXT_KEY) || 'null');
      sessionStorage.removeItem(EXT_KEY);
    } catch (error) {
      record = null;
    }
    const now = paintedSig();
    if (!record || typeof record.before !== 'string' || now === null || !(Date.now() - record.seen < 30000)) return;
    trackExternalAdd(record.before, now);
  };

  let verifyTimer = null;
  let pendingAdd = null;
  const scheduleVerify = () => {
    clearTimeout(verifyTimer);
    verifyTimer = setTimeout(
      () => {
        const drawer = getDrawer();
        if (!drawer || typeof drawer.verify !== 'function') return;
        drawer.verify().then((changed) => {
          const add = pendingAdd;
          pendingAdd = null;
          // Sin cambio = el carro ya estaba pintado (el tema lo pintó con renderContents): no es ajeno.
          if (!add || !changed || isOwn(add.at)) return;
          if (!drawer.classList.contains('active')) {
            drawer.skipVerify = true;
            drawer.open();
          }
          trackExternalAdd(add.before, drawer.paintedSig());
        });
      },
      pendingAdd ? 0 : 300
    );
  };

  if ('PerformanceObserver' in window) {
    try {
      const origin = typeof performance.timeOrigin === 'number' ? performance.timeOrigin : Date.now() - performance.now();
      new PerformanceObserver((list) => {
        let hit = false;
        list.getEntries().forEach((entry) => {
          const url = String(entry.name || '');
          const at = origin + entry.startTime;
          if (!CART_RE.test(url)) return;
          hit = true; // lo propio también se verifica (se repinta sin abrir), como dice K2
          if (isOwn(at)) return;
          const failed = typeof entry.responseStatus === 'number' && entry.responseStatus >= 400;
          const before = paintedSig();
          if (/\/cart\/add/.test(url) && !failed && !pendingAdd && before !== null) {
            pendingAdd = { before, at, seen: Date.now() };
          }
        });
        if (hit) scheduleVerify();
      }).observe({ type: 'resource', buffered: false });
    } catch (error) {
      /* Sin PerformanceObserver: queda verify() al abrir el carro. */
    }
  }

  window.addEventListener('pagehide', () => {
    const add = pendingAdd;
    pendingAdd = null;
    if (!add || isOwn(add.at) || paintedSig() !== add.before) return;
    try {
      sessionStorage.setItem(EXT_KEY, JSON.stringify({ before: add.before, seen: add.seen }));
    } catch (error) {
      /* sin sessionStorage no se mide */
    }
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const drawer = getDrawer();
    if (drawer && typeof drawer.verify === 'function') drawer.verify().then(resumeExternalAdd);
  });

  let hiddenAt = 0;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') {
      hiddenAt = Date.now();
      return;
    }
    const away = hiddenAt ? Date.now() - hiddenAt : 0;
    hiddenAt = 0;
    const drawer = getDrawer();
    if (away >= 1000 && drawer && typeof drawer.verify === 'function') drawer.verify();
  });

  /* Atrás/Adelante sin bfcache sirve el HTML desde la caché del navegador: el carro y la burbuja pintados pueden ser
     de antes. Se verifica primero y después se mide el agregado pendiente. */
  const nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
  const cached = !!nav && (nav.type === 'back_forward' || nav.deliveryType === 'cache');
  const first = getDrawer();
  if (cached && first && typeof first.verify === 'function') first.verify().then(resumeExternalAdd);
  else resumeExternalAdd();
})();